import { useRouter } from 'next/router';
import { tabsValues } from '../../../config/pageConfig';
import Banner from '../components/Banner';
import RewardCards from '../components/RewardCards';
import EventStatus from '../components/EventStatus';
import Process from '../components/Process';
import ActivityRules from '../components/ActivityRules';
import ModalOrchestrator from '../modals/ModalOrchestrator';
import { useServiceRenewalFlow } from '../hooks/useServiceRenewalFlow';

export default function StatusItem() {
    const { query } = useRouter();
    const searchTab = query?.tab;
    let defaultTab = 'Product';
    if (typeof searchTab === 'string' && tabsValues.includes(searchTab)) {
        defaultTab = searchTab;
    }

    const flow = useServiceRenewalFlow();

    return (
        <>
            <Banner />
            <RewardCards
                onJoinNow={flow.handleJoinNow}
                onMyMysteryBox={flow.handleMyMysteryBox}
                isLoggedIn={flow.isLoggedIn}
                campaignId={flow.campaign.campaignId ?? undefined}
            />

            <Process
                onJoinNow={flow.handleJoinNow}
                onMyMysteryBox={flow.handleMyMysteryBox}
                isLoggedIn={flow.isLoggedIn}
                campaignId={flow.campaign.campaignId ?? undefined}
            />
            <EventStatus />
            <ActivityRules />
            <ModalOrchestrator flow={flow} />
        </>
    );
}
